<template>
 <v-app :style="{background: $vuetify.theme.themes['light'].background}" >
   <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
  import html2canvas from 'html2canvas'
  import { mapFields } from 'vuex-map-fields'
  export default {
    
    beforeMount() {},
    data () {
      return {
        
      }
    },
    mounted: function () {
      this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
      })
    },
    computed: {
      isAuthenticated () {
        return this.$store.getters.isAuthenticated
      },
      ...mapFields([
        'settings.isAuthenticated',
        'settings.isSalesView',
        'settings.isOfficeView',
        'settings',
        'device',
        'labels',
        'menu',
        'user',
      ])
    },
    methods: {
      onResize() {
        if(window.innerWidth <= 800) this.device = 'mobile'
        else this.device = 'desktop'
        //this.windowWidth = window.innerWidth
      },
      userSignOut () {
        this.$store.dispatch('userSignOut')
      },
      mnotify(type,message) {
        if(type === 'good') this.$snotify.success(message, null, {timeout: 300,showProgressBar: false});
        //if(type === 'bad') this.$snotify.error(message, null, {timeout: 300,showProgressBar: false});
        //this.$snotify.success('Saved!', 'Example title');
      },
      addRow: function (event) {
        var lastId =  this.labels.length;
        var newRow={
          id: this.nextBarId++, 
          percentual: this.newRow.value, 
          label: this.newRow.label , 
          icon: this.newRow.icon
        };
        this.labels.push( newRow );
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/App.vue